export const StaffActions = {
    UPDATE_LIST: 'UPDATE_LIST'
};